import { useEffect, useRef } from 'react';

/**
 * Print portal SEO card (owner 2026-10-21). The card is server-rendered by the
 * Shopify order-prints page template (`#rpl-seo-card`, `hidden`) so Google can
 * read the heading and product names without running the app. This slot adopts
 * that node into the upload screen's empty state and shows it; when the slot
 * unmounts (first photo added) the node is hidden and parked again so it can
 * come back if every photo is removed. Outside the theme (dev, tests) there is
 * no node and the slot renders nothing visible.
 */
export function SeoCardSlot() {
  const slotRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const card = document.getElementById('rpl-seo-card');
    const slot = slotRef.current;
    if (!card || !slot) return;
    const home = card.parentElement;
    slot.appendChild(card);
    card.hidden = false;
    return () => {
      card.hidden = true;
      (home && home.isConnected ? home : document.body).appendChild(card);
    };
  }, []);
  return <div ref={slotRef} className="upload__seo" />;
}
